// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__1ZOmj"};